howspace.annotation = (() => {
    'use strict';

    real.onTierReady(real.TIER_2, () => {
        real.events.on('widget:annotations:updated', (notification) => {
            updateAnnotationsCount(notification.object);
        });

        real.events.on('workspace:page:changed', () => {
            pageChangedNotified = false;
        });

        showPageChangedNoticeAfterReload();

        howspace.widgets.onEvent('widget:pin:added', (widget, notification) => addPin(widget, notification));

        howspace.widgets.onEvent('widget:pin:updated', (widget, notification) => {
            const annotation = widget.find('.annotation-pin[data-pin-id="' + notification.object.pin.id + '"]');

            if (annotation.length > 0) {
                annotation.findIncludingSelf('*').off().removeData().remove();
            }

            addPin(widget, notification, true);
        });

        howspace.widgets.onEvent('widget:pin:removed', (widget, notification) => {
            const pin = widget.find('.annotation-pin[data-pin-id="' + notification.object.pin.id + '"]');

            if (pin.length === 0) {
                // Pin not found.
                return;
            }

            removePin(widget, pin);
        });

        howspace.widgets.onEvent('widget:pins:removed', (widget, notification) => {
            let pins;
            if (notification.object.pin?.option?.id) {
                pins = widget.find('.annotation-pin[data-option-id="' + notification.object.pin.option.id + '"]');
            } else {
                pins = widget.find('.annotation-pin');
            }

            pins.each(function () {
                removePin(widget, $(this));
            });
        });
    });

    const checkNoTouch = () => {
        if ($('.is-pinning, .is-resizing').length > 0) {
            real.dom.$body.addClass('no-touch');
        } else {
            real.dom.$body.removeClass('no-touch');
        }
    };

    const updateAnnotationsCount = (object) => {
        const widget = $('#widget-' + object.widget.id);
        if (widget.length === 0) {
            return;
        }

        const btn = widget.find('.filter-btn');

        if (object.widget.type !== 'pdf') {
            let annotationCount = object.annotations;
            if (object.annotations === 0) {
                annotationCount = '';
            }
            btn.html(btn.html().replace(/<\/i>.*$/, '</i>' + annotationCount));
            if (object.annotations) {
                btn.removeClass('d-none');
            } else {
                btn.addClass('d-none');
            }
        } else {
            btn.dataAndAttr('annotations', object.annotations.join(','));

            const pdfViewer = widget.find('.howspace-pdf-viewer');
            const currentPage = howspace.components.pdfViewer.getCurrentPage(pdfViewer);
            updateAnnotationsCountOnPage(widget, currentPage);
        }
    };

    const updateAnnotationsCountOnPage = (widget, page) => {
        if (widget.length > 0) {
            const btn = widget.find('.filter-btn');
            if (btn.length > 0) {
                const annotations = btn.data('annotations');
                if (annotations !== undefined) {
                    let annotationCount = parseInt(String(annotations).split(',')[page - 1]);
                    if (annotationCount) {
                        btn.removeClass('d-none');
                    } else {
                        btn.addClass('d-none');
                    }
                    if (annotationCount === 0) {
                        annotationCount = '';
                    }
                    btn.html(btn.html().replace(/<\/i>.*$/, '</i>' + annotationCount));
                }
            }
        }
    };

    const addPin = (widget, notification, update = false) => {
        const viewer = widget.find('.annotation-viewer');

        const page = notification.object.pin.page;

        const annotation = $(notification.object.pin.html);
        viewer.append(annotation);

        const isMyPin = real.events.isFromCurrentUser(notification) || notification.object.user?.id === real.dom.$body.data('user-id');
        if (isMyPin) {
            annotation.addClass('my-pin');
            if (widget.data('pinning-visibility') === 'all_after_pinned') {
                // User cannot see others' pins before adding own pin.
                if (viewer.data('my-pins-count') === 0) {
                    // User does not yet have own pins.
                    getPins(widget, page);
                }
            }

            stopPinning(widget);
        }

        // The server decides per viewer whether the pin is editable, the pin's owner included.
        if (notification.object.can_edit ?? isMyPin) {
            annotation.addClass('editable');
            widget.find('.annotation-toolbar .trash-btn.d-none').removeClass('d-none');
            if (widget.data('widget-type') === 'canvas') {
                annotation.addClass('draggable');
            }

            attachMyPinHandlers(widget, annotation);
        }

        let editMode = false;
        if (real.events.isFromCurrentWindow(notification)) {
            annotation.addClass('new-pin');
            if (!update && (annotation.data('type') === 'note' || annotation.data('type') === 'label')) {
                annotation.trigger('click');
                editMode = true;
            }
        }

        if (page) {
            const pdfViewer = widget.find('.howspace-pdf-viewer');
            const currentPage = howspace.components.pdfViewer.getCurrentPage(pdfViewer);
            showPinsForPage(widget, currentPage);
        } else {
            countMyPins(viewer);
        }

        if (!editMode) {
            howspace.components.translator.init(annotation);
        }

        howspace.components.picture.init(viewer);
    };

    const showPinsForPage = function (widget, page) {
        const viewer = widget.find('.annotation-viewer');

        // Hide all pins.
        viewer.find('.annotation-pin').addClass('d-none');

        // Current user's pins on given page.
        const myPins = viewer.find('.annotation-pin.my-pin.pdf-page-' + page);

        if (widget.data('pinning-visibility') === 'all_after_pinned') {
            // User cannot see others' pins before adding own pin.
            if (myPins.length === 0) {
                // User does not yet have own pins on this page.
                countMyPins(viewer);
                return;
            }
        }

        const legend = widget.find('.annotation-legend');
        viewer.find('.annotation-pin.pdf-page-' + page).each(function () {
            const pin = $(this);
            if (legend.length > 0) {
                if (legend.find('.pinning-option-badge.selected[data-id="' + pin.data('option-id') + '"]').length > 0) {
                    pin.removeClass('d-none');
                }
            } else {
                pin.removeClass('d-none');
            }
        });

        countMyPins(viewer);
    };

    const removePin = (widget, pin) => {
        // Remove all event handlers and data
        pin.findIncludingSelf('*').off().removeData();

        // Remove annotation.
        pin.remove();

        // Count my pins.
        const viewer = widget.find('.annotation-viewer');
        countMyPins(viewer);

        // Hide "max pins given" notification if it's visible.
        hideMaxPinsGivenNotification();
    };

    const isPinning = (widget) => {
        return widget.hasClass('is-pinning');
    }

    const setIsPinning = (widget, pinning) => {
        if (widget.hasClass('is-deleting')) {
            widget.removeClass('is-deleting');
            widget.find('.annotation-toolbar .trash-btn').removeClass('selected');
        }

        if (pinning) {
            widget.addClass('is-pinning');
            checkNoTouch();
        } else {
            widget.removeClass('is-pinning');
            checkNoTouch();
            widget.find('.annotation-toolbar .btn').removeClass('selected').trigger('blur');
        }
    }

    const startPinning = (widget) => {
        setIsPinning(widget, true);

        howspace.widgets[widget.data('widget-type')]['startAnnotating'](widget);

        const viewer = widget.find('.annotation-viewer');
        viewer.on('click', pinClick);
    };

    const stopPinning = (widget) => {
        setIsPinning(widget, false);
        widget.find('.annotation-toolbar .btn').removeClass('selected');

        howspace.widgets[widget.data('widget-type')]['stopAnnotating'](widget);

        const viewer = widget.find('.annotation-viewer');

        viewer.removeDataAndAttr('pinning-content');
        viewer.removeDataAndAttr('pinning-option-id');

        viewer.off('click', pinClick);
    };

    const showMaxPinsGivenNotification = () => {
        const notification = real.notification.show(howspace.translate('common_max_pins_given'), 'danger');
        notification.addClass('max-pins-given-notification');
    };

    const hideMaxPinsGivenNotification = () => {
        if ($('#real-notification-bar.max-pins-given-notification').length > 0) {
            $('#real-notification-bar').removeClass('max-pins-given-notification');
            real.notification.hide();
        }
    };

    const showAnnotatedNotification = () => {
        const notification = real.notification.show(howspace.translate('common_annotation_selected_notification'));
        notification.addClass('annotated-notification');
    };

    const hideAnnotatedNotification = () => {
        if ($('#real-notification-bar.annotated-notification').length > 0) {
            $('#real-notification-bar').removeClass('annotated-notification');
            real.notification.hide();
        }
    };

    const getLeft = (viewer, x) => {
        return parseInt(x) / viewer.width() * 100;
    }

    const getTop = (viewer, y) => {
        return parseInt(y) / viewer.height() * 100;
    }

    const pinClick = (e) => {
        if (e?.originalEvent?.pointerType === 'mouse' && e?.originalEvent?.button !== 0) {
            // Do not add pin if the pointer is mouse and user didn't click with left button.
            return;
        }

        const target = $(e.currentTarget);
        const viewer = target.closest('.annotation-viewer');
        const widget = viewer.closest('.widget');

        const tool = getSelectedTool(widget);
        const left = getLeft(viewer, e.originalEvent.offsetX);
        const top = getTop(viewer, e.originalEvent.offsetY);
        const noteCategory = real.localStorage.get('latest-note-category') || 0;

        switch (tool) {
            case 'pin':
                if (viewer.is('.max-pins-given')) {
                    showMaxPinsGivenNotification();
                    return;
                }

                postPinAnnotation(viewer, tool, left, top, {option: viewer.data('pinning-option-id')});
                break;

            case 'emoji':
                if (viewer.is('.max-pins-given')) {
                    showMaxPinsGivenNotification();
                    return;
                }

                postPinAnnotation(viewer, tool, left, top, {metadata: {content: viewer.data('pinning-content')}});
                break;

            case 'note':
            case 'label':
                postPinAnnotation(viewer, tool, left, top, {metadata: {content: '', category: noteCategory}});
                break;
        }
    };

    // The page can change after it was drawn, for example when a facilitator moves the path on or the page turns
    // read-only. The server then refuses annotation changes, which is expected, so the page reloads to catch up.
    const isPageChangedRefusal = response => {
        return real.ajax.hasErrorKey(response, 'widget_not_viewable') || real.ajax.hasErrorKey(response, 'page_not_active');
    };

    // Someone else deleted the annotation before this page heard about it.
    const isAnnotationGone = response => response.status === 404;

    const isExpectedRefusal = response => isPageChangedRefusal(response) || isAnnotationGone(response);

    // Lets the page tell the user after an automatic reload why their change is gone.
    const PAGE_CHANGED_STORAGE_KEY = 'howspace-annotation-page-changed-at';
    const PAGE_CHANGED_NOTICE_MAX_AGE_MS = 30 * 1000;

    let pageChangedNotified = false;
    const handlePageChangedRefusal = () => {
        if (pageChangedNotified) {
            return;
        }
        pageChangedNotified = true;
        try {
            window.sessionStorage.setItem(PAGE_CHANGED_STORAGE_KEY, String(Date.now()));
        } catch (e) {
            // Without storage the reloaded page just does not repeat the message.
        }
        real.window.reloadPageOrNotifyUser(howspace.translate('common_annotation_page_changed'));
    };

    const showPageChangedNoticeAfterReload = () => {
        let changedAt = null;
        try {
            changedAt = Number(window.sessionStorage.getItem(PAGE_CHANGED_STORAGE_KEY));
            window.sessionStorage.removeItem(PAGE_CHANGED_STORAGE_KEY);
        } catch (e) {
            return;
        }
        if (changedAt && Date.now() - changedAt < PAGE_CHANGED_NOTICE_MAX_AGE_MS) {
            real.notification.show(howspace.translate('common_annotation_page_changed'), 'warning');
        }
    };

    const postPinAnnotation = (viewer, type, left, top, dataPayload) => {
        const widget = viewer.closest('.widget');

        if (widget.length === 0 || isNaN(left) || isNaN(top)) {
            return;
        }

        const metadata = dataPayload.metadata || {};
        metadata.left = left;
        metadata.top = top;
        if (widget.data('widget-type') === 'pdf') {
            const pdfViewer = widget.find('.howspace-pdf-viewer');
            metadata.page = howspace.components.pdfViewer.getCurrentPage(pdfViewer);
        }

        dataPayload = $.extend({
            type: type,
            widget: {
                oid: widget.data('widget-id'),
                type: widget.data('widget-type')
            },
            parent: {
                id: real.dom.$body.data('user-id')
            },
            metadata: metadata
        }, dataPayload);

        real.ajax.json(real.baseUri + '/api/annotations', {
            type: 'POST',
            data: JSON.stringify(dataPayload),
            showErrorNotification: response => !isPageChangedRefusal(response),
            logError: response => !isPageChangedRefusal(response),
            error: response => {
                if (isPageChangedRefusal(response)) {
                    handlePageChangedRefusal();
                }
            }
        });
    };

    const updateAnnotationMetadata = (viewer, annotation, metadata) => {
        const id = annotation.data('pin-id');
        const dataPayload = {
            metadata: metadata
        };
        real.ajax.json(real.baseUri + '/api/annotation/' + id, {
            type: 'POST',
            data: JSON.stringify(dataPayload),
            showErrorNotification: false,
            logError: response => !isExpectedRefusal(response),
            error: response => {
                if (isPageChangedRefusal(response)) {
                    handlePageChangedRefusal();
                } else if (isAnnotationGone(response)) {
                    removePin(annotation.closest('.widget'), annotation);
                } else {
                    real.notification.show(howspace.translate('layout_general_reload_page_error'), 'danger');
                }
            }
        });
    };

    const postAnnotation = (widget, parent) => {
        const sourceWidget = $('.widget.is-annotating');
        if (sourceWidget.length === 0) {
            return;
        }

        const viewer = sourceWidget.find('.annotation-viewer');
        const rect = viewer.find('.selection-rect');
        if (rect.length === 0) {
            return;
        }

        // Show the progress bar for the upload process.
        parent.find('.upload-progress').removeClass('d-none');

        const dataPayload = {
            _action: 'annotate',
            upload_process_token: real.uid(),
            widget_id: widget.data('widget-id'),
            source_widget_type: sourceWidget.data('widget-type'),
            source_widget_id: sourceWidget.data('widget-id'),
            width: viewer.width(),
            height: viewer.height(),
            offset_x: rect.css('left').replace('px', ''),
            offset_y: rect.css('top').replace('px', ''),
            crop_width: rect.css('width').replace('px', ''),
            crop_height: rect.css('height').replace('px', '')
        };

        if (sourceWidget.data('widget-type') === 'pdf') {
            const pdfViewer = sourceWidget.find('.howspace-pdf-viewer');
            dataPayload.page = howspace.components.pdfViewer.getCurrentPage(pdfViewer);
        }

        parent.dataAndAttr('upload-token', dataPayload.upload_process_token);

        real.ajax.json(howspace.widgets.getApiUrl(widget), {
            type: 'POST',
            data: JSON.stringify(dataPayload),
            success: () => {
                howspace.components.progress.update(widget.find('.upload-progress'), 75);
                stopAnnotating(sourceWidget);
            }
        });
    };

    const countMyPins = (viewer) => {
        const myPinsCount = viewer.find('.my-pin:visible').length;

        const widget = viewer.closest('.widget');
        const maxPins = widget.data('pinning-limit');

        viewer.dataAndAttr('my-pins-count', myPinsCount);

        if (maxPins > 0 && myPinsCount >= maxPins) {
            viewer.addClass('max-pins-given');
        } else {
            viewer.removeClass('max-pins-given');

            hideMaxPinsGivenNotification();
        }
    };

    const handleEditablePinClicked = (e) => {
        const annotation = $(e.currentTarget);
        const widget = annotation.closest('.widget');
        if (widget.data('widget-type') !== 'canvas' && removeMyPin($(e.currentTarget))) {
            return false;
        }
    };

    const removeMyPin = annotation => {
        const widget = annotation.closest('.widget');
        const viewer = widget.find('.annotation-viewer');

        if (widget.data('widget-type') !== 'canvas' && !isPinning(widget)) {
            // Pinning is not enabled. Only remove pin when pinning mode is on.
            return false;
        }

        const removeAnnotation = () => {
            // Remove all event handlers and data
            annotation.findIncludingSelf('*').off().removeData();

            // Remove annotation.
            annotation.remove();

            if (viewer.find('.editable').length === 0) {
                widget.find('.annotation-toolbar .trash-btn').addClass('d-none');
            }

            // Count my pins.
            countMyPins(viewer);
        };

        real.ajax.json(real.baseUri + '/api/annotation/' + annotation.data('pin-id'), {
            type: 'DELETE',
            showErrorNotification: response => !isExpectedRefusal(response),
            logError: response => !isExpectedRefusal(response),
            success: removeAnnotation,
            error: response => {
                if (isPageChangedRefusal(response)) {
                    handlePageChangedRefusal();
                } else if (isAnnotationGone(response)) {
                    removeAnnotation();
                }
            }
        });

        return true;
    };

    const attachMyPinHandlers = (widget, annotation) => {
        howspace.components.init(annotation);
        annotation.on('click', handleEditablePinClicked);

        if (widget.data('widget-type') === 'canvas') {
            annotation.addClass('draggable');
        }
    };

    const getPins = (widget, page) => {
        const widgetId = widget.data('widget-id');
        const widgetType = widget.data('widget-type');
        if (widgetId === undefined || widgetType === undefined) {
            return;
        }

        const viewer = widget.find('.annotation-viewer');

        const successFn = (response) => {
            const html = $(response.html);

            viewer.find('.annotation-pin').remove();
            viewer.append(html);
            const editablePins = viewer.find('.editable');
            if (editablePins.length === 0) {
                widget.find('.annotation-toolbar .trash-btn').addClass('d-none');
            }
            editablePins.each(function () {
                attachMyPinHandlers(widget, $(this));
            });

            if (page) {
                showPinsForPage(widget, page);
            } else {
                countMyPins(viewer);
            }

            howspace.components.init(viewer);
        }

        const dataPayload = {
            widget: {
                id: widgetId,
                type: widgetType
            },
            show_all: widget.data('pinning-visibility') === 'all',
            filter: howspace.widgets.getFilter(widget)
        };

        real.ajax.json(real.baseUri + '/annotations/pins', {
            type: 'POST',
            data: JSON.stringify(dataPayload),
            showErrorNotification: response => !isPageChangedRefusal(response),
            logError: response => !isPageChangedRefusal(response),
            success: (response) => {
                successFn(response);
            }
        });
    };

    const initConfirmDeleteAnnotationsModal = (widget, modal) => {
        const deleteBtn = modal.find('.delete-btn');
        deleteBtn.on('click', () => {
            real.button.loading(deleteBtn, modal);

            real.ajax.json(howspace.widgets.getApiUrl(widget) + '/annotations', {
                type: 'DELETE',
                success: () => {
                    howspace.components.modal.close(modal);
                },
                error: () => {
                    real.button.reset(deleteBtn, modal);
                }
            });
        });
    };

    const removeAllPins = (e) => {
        const btn = $(e.currentTarget);
        const widget = btn.closest('.widget');
        const url = howspace.widgets.getUrl(widget) + '/confirm-delete-annotations-modal';

        howspace.components.dropdown.close(btn.closest('.dropdown'))

        howspace.components.modal.show(url, (modal) => {
            initConfirmDeleteAnnotationsModal(widget, $(modal));
        });
    };

    const isAnnotating = (widget) => {
        return widget.hasClass('is-annotating');
    };

    const stopAnnotating = (widget) => {
        hideAnnotatedNotification();

        if (widget.hasClass('is-deleting')) {
            widget.removeClass('is-deleting');
            widget.find('.annotation-toolbar .trash-btn').removeClass('selected');
        }
        widget.removeClass('is-annotating');

        const viewer = widget.find('.annotation-viewer');
        viewer.find('.selection-rect').remove();

        viewer.removeDataAndAttr('x0');
        viewer.removeDataAndAttr('y0');
        viewer.removeDataAndAttr('selecting');

        viewer.off('pointerdown', pointerdownFn);
        viewer.off('pointermove', pointermoveFn);
        viewer.off('pointerup', pointerupFn);

        howspace.widgets[widget.data('widget-type')]['stopAnnotating'](widget);
    };

    const drawAnnotation = (viewer, left, top, width, height, unit, opacity) => {
        if (!width || !height) {
            opacity = '0';
        }

        const rect = viewer.find('.selection-rect');
        if (rect.length > 0) {
            rect.css('left', left + unit);
            rect.css('top', top + unit);
            rect.css('width', width + unit);
            rect.css('height', height + unit);
            rect.css('opacity', opacity);
        }
    };

    const redrawAnnotationWithRelativeCoordinates = (viewer, options) => {
        drawAnnotation(viewer, options.left, options.top, options.width, options.height, '%', '1');
    };

    const redrawAnnotation = (viewer, x1, y1) => {
        const x0 = viewer.data('x0');
        const y0 = viewer.data('y0');
        const left = Math.min(x0, x1);
        const width = Math.max(x0, x1) - left;
        const top = Math.min(y0, y1);
        const height = Math.max(y0, y1) - top;

        drawAnnotation(viewer, left, top, width, height, 'px', '1');
    };

    const redrawPointerAnnotation = (e) => {
        const viewer = $(e.currentTarget);
        if (e && e.originalEvent && viewer.data('selecting')) {
            const rect = e.currentTarget.getBoundingClientRect();
            const x1 = e.originalEvent.clientX - rect.left;
            const y1 = e.originalEvent.clientY - rect.top;
            redrawAnnotation(viewer, x1, y1);
        }
    };

    const endSelection = (viewer) => {
        const viewerWidth = viewer.width();
        const viewerHeight = viewer.height();
        const rect = viewer.find('.selection-rect');
        const width = rect.width();
        const height = rect.height();

        redrawAnnotationWithRelativeCoordinates(viewer, {
            left: parseInt(rect.css('left').replace('px', '')) / viewerWidth * 100,
            top: parseInt(rect.css('top').replace('px', '')) / viewerHeight * 100,
            width: width / viewerWidth * 100,
            height: height / viewerHeight * 100,
        });

        viewer.dataAndAttr('selecting', false);

        if (width > 0 || height > 0) {
            showAnnotatedNotification();
        } else {
            hideAnnotatedNotification();
        }
    };

    const pointerdownFn = (e) => {
        if (e?.originalEvent?.pointerType === 'mouse' && e?.originalEvent?.button !== 0) {
            // Do not start selecting if the pointer is mouse and user didn't click with left button.
            return;
        }

        const viewer = $(e.currentTarget);
        try {
            e.currentTarget.setPointerCapture(e.originalEvent.pointerId);
        } catch (e) {
            // Ignore the error if the target doesn't support pointer capture.
        }
        const rect = e.currentTarget.getBoundingClientRect();
        viewer.dataAndAttr('x0', e.originalEvent.clientX - rect.left);
        viewer.dataAndAttr('y0', e.originalEvent.clientY - rect.top);
        viewer.dataAndAttr('selecting', true);
    };

    const pointermoveFn = (e) => {
        redrawPointerAnnotation(e);
    };

    const pointerupFn = (e) => {
        const viewer = $(e.currentTarget);
        if (!viewer.data('selecting')) {
            return;
        }

        redrawPointerAnnotation(e);
        try {
            e.currentTarget.releasePointerCapture(e.originalEvent.pointerId);
        } catch (e) {
            // Ignore the error if the target doesn't support pointer capture.
        }
        endSelection(viewer);
    };

    const startAnnotating = (widget) => {
        if (widget.hasClass('is-deleting')) {
            widget.removeClass('is-deleting');
            widget.find('.annotation-toolbar .trash-btn').removeClass('selected');
        }

        widget.addClass('is-annotating');

        const viewer = widget.find('.annotation-viewer');
        viewer.find('.selection-rect').remove();
        viewer.append('<div class="selection-rect"></div>');

        viewer.on('pointerdown', pointerdownFn);
        viewer.on('pointermove', pointermoveFn);
        viewer.on('pointerup', pointerupFn);

        howspace.widgets[widget.data('widget-type')]['startAnnotating'](widget);
    };

    const showAnnotation = (elem) => {
        const readyFn = () => {
            const widget = $('#widget-' + elem.data('annotation-widget-id'));
            if (widget.length === 0) {
                return;
            }

            const viewer = widget.find('.annotation-viewer');
            if (viewer.length === 0) {
                return;
            }
            if (viewer.data('uploadedfile-id') !== elem.data('annotation-uploadedfile-id')) {
                return;
            }

            let rect = viewer.find('.selection-rect');
            if (rect.length === 0) {
                viewer.append('<div class="selection-rect"></div>');
                rect = viewer.find('.selection-rect');
            }

            const redrawFn = () => {
                redrawAnnotationWithRelativeCoordinates(viewer, {
                    left: elem.data('annotation-left'),
                    top: elem.data('annotation-top'),
                    width: elem.data('annotation-width'),
                    height: elem.data('annotation-height')
                });

                howspace.scroller.scrollToElement(rect);
            };

            if (widget.data('widget-type') === 'pdf') {
                const pdfViewer = widget.find('.howspace-pdf-viewer');
                howspace.components.pdfViewer.showPage(pdfViewer, elem.data('annotation-page'), null, redrawFn);
                return;
            }

            redrawFn();
        };

        const sourceWidgetPagePath = String(elem.data('annotation-widget-page-path') ?? '').trim();
        const currentPath = String(real.dom.$body.data('page-path') ?? '').trim();

        if (sourceWidgetPagePath && currentPath !== sourceWidgetPagePath) {
            // TODO change page to source widget page
            alert('TODO change page to source widget page');
        } else {
            readyFn();
        }
    };

    const hideAnnotation = (widget) => {
        const viewer = widget.find('.annotation-viewer');
        drawAnnotation(viewer, 0, 0, 0, 0, 'px', '0');

        hideAnnotatedNotification();
    };

    const hidePins = (widget) => {
        const viewer = widget.find('.annotation-viewer');
        viewer.find('.annotation-pin').addClass('d-none');
    };

    const isFiltering = (widget) => {
        return widget.hasClass('is-filtering');
    };

    const startFiltering = (widget) => {
        $('.widget.is-filtering').each(function () {
            $(this).removeClass('is-filtering');
        });

        widget.addClass('is-filtering');

        filterDiscussionWidgets(widget);
    };

    const stopFiltering = (widget) => {
        widget.removeClass('is-filtering');

        unfilterDiscussionWidgets(widget);
    };

    const filterDiscussionWidgets = (widget, page = undefined, scroll = true) => {
        const viewer = widget.find('.annotation-viewer');
        let filterValue = viewer.data('uploadedfile-id');
        if (widget.data('widget-type') === 'pdf') {
            const pdfViewer = widget.find('.howspace-pdf-viewer');
            filterValue += '_' + howspace.components.pdfViewer.getCurrentPage(pdfViewer);
        }

        const discussionWidgets = $('.widget-discussion:visible');
        discussionWidgets.each(function () {
            const widget = $(this);
            const filterInfo = widget.find('.howspace-filter-info');

            howspace.components.filterInfo.filterByAnnotation(filterInfo, widget, filterValue);
        });

        if (scroll && discussionWidgets.length > 0) {
            howspace.scroller.scrollToElement(discussionWidgets[0]);
        }
    };

    const unfilterDiscussionWidgets = (widget) => {
        hideAnnotation(widget);

        $('.widget-discussion').each(function () {
            const widget = $(this);
            const filterInfo = widget.find('.howspace-filter-info');

            howspace.components.filterInfo.filterByAnnotation(filterInfo, widget, null);
        });
    };

    const handlePageLoading = (widget) => {
        hideAnnotation(widget);
        hidePins(widget);
    };

    const handlePageChanged = (widget, page) => {
        updateAnnotationsCountOnPage(widget, page);

        showPinsForPage(widget, page);

        if (isFiltering(widget)) {
            filterDiscussionWidgets(widget, page, false);
        }
    };

    const getSelectedTool = (widget) => {
        return widget.find('.annotation-toolbar .btn.selected').data('type');
    };

    const initAnnotationTool = (widget, toolbar) => {
        // Filter button.
        widget.find('.filter-btn').on('click', () => {
            if (isFiltering(widget)) {
                stopFiltering(widget);
            } else {
                startFiltering(widget);
            }
        });

        // Annotate button.
        toolbar.find('.annotate-btn').on('click', () => {
            if (isAnnotating(widget)) {
                stopAnnotating(widget);
            } else {
                if (isPinning(widget) || toolbar.find('.emoji-btn').hasClass('selected')) {
                    stopPinning(widget);
                }
                startAnnotating(widget);
            }
        });
    };

    const initPinTool = (widget, legend, viewer, toolbar) => {
        const optionsBtn = toolbar.find('.pin-options-btn');

        // Remove all pins button.
        widget.find('.remove-pins-btn').on('click', removeAllPins);

        const togglePinningLegend = (e) => {
            const option = $(e.currentTarget);
            const id = option.data('id');
            const widget = option.closest('.widget');
            const viewer = widget.find('.annotation-viewer');
            const pins = viewer.find('.annotation-pin[data-option-id="' + id + '"]');

            if (option.hasClass('selected')) {
                option.removeClass('selected');
                pins.hide();
            } else {
                option.addClass('selected');

                switch (widget.data('widget-type')) {
                    case 'image':
                        pins.show();
                        break;

                    case 'pdf':
                        const pdfViewer = widget.find('.howspace-pdf-viewer');
                        const currentPage = howspace.components.pdfViewer.getCurrentPage(pdfViewer);
                        viewer.find('.annotation-pin[data-option-id="' + id + '"].pdf-page-' + currentPage).show();
                        break;
                }
            }
        };

        // Pinning legend badge.
        legend.find('.pinning-option-badge').on('click', togglePinningLegend);
        legend.find('.pinning-option-badge').on('keydown', (e) => {
            if (e.keyCode === 13 || e.keyCode === 32) {
                togglePinningLegend(e);
                return false;
            }
        });

        // Pin button.
        toolbar.find('.pin-btn').on('click', (e) => {
            if (isAnnotating(widget)) {
                stopAnnotating(widget);
            }

            if (getSelectedTool(widget) === 'pin') {
                stopPinning(widget);
            } else {
                stopPinning(widget);

                const btn = $(e.currentTarget);
                const optionId = btn.data('pinning-option-id');

                if (optionId) {
                    const viewer = widget.find('.annotation-viewer');
                    viewer.dataAndAttr('pinning-option-id', optionId);

                    const dropdown = btn.closest('.dropdown');
                    howspace.components.dropdown.close(dropdown);
                }

                btn.addClass('selected');
                startPinning(widget);
            }
        });

        // Pinning options dropdown.
        optionsBtn.on('click', (e) => {
            if (isPinning(widget)) {
                stopPinning(widget);
                e.stopPropagation();
            }
        });

        viewer.on('click', '.avatar', (e) => {
            if (e.target.closest('.dropped') !== null) {
                // Target was drag-and-dropped. Do not open avatar.
                return false;
            }

            if (!widget.hasClass('is-deleting')) {
                // Manually trigger click on avatar img because pointer events are disabled.
                $(e.target).find('img').trigger('click');
            }
        });
    };

    const initEmojiTool = (widget, viewer, toolbar) => {
        const emojiBtn = toolbar.find('.emoji-btn');

        // Emoji button.
        emojiBtn.on('click', () => {
            if (isAnnotating(widget)) {
                stopAnnotating(widget);
            }

            if (getSelectedTool(widget) === 'emoji') {
                const emoji = viewer.data('pinning-content');
                stopPinning(widget);
                if (emoji) {
                    emojiBtn.addClass('selected');
                }
            } else {
                stopPinning(widget);
                emojiBtn.addClass('selected');
            }
        });

        toolbar.on(howspace.components.emojiPicker.EMOJI_PICKED, (e) => {
            viewer.data('pinning-content', e.detail.emoji.native);
            emojiBtn.addClass('selected');
            startPinning(widget);
        });

        toolbar.on(howspace.popover.POPOVER_CLOSED, (e) => {
            if (e.target.classList.contains('howspace-emoji-picker') && !viewer.data('pinning-content')) {
                stopPinning(widget);
            }
        });
    };

    const initLabelTool = (widget, viewer, toolbar) => {
        const labelBtn = toolbar.find('.label-btn');

        labelBtn.on('click', () => {
            if (isAnnotating(widget)) {
                stopAnnotating(widget);
            }

            if (getSelectedTool(widget) === 'label') {
                stopPinning(widget);
            } else {
                stopPinning(widget);
                labelBtn.addClass('selected');
                startPinning(widget);
            }
        });

        const handleClick = (e) => {
            if (widget.hasClass('is-deleting')) {
                return;
            }
            const textarea = $('<textarea rows="1" class="text-editor autosize autosize-width" style="--autosize-margin: 2px"></textarea>');
            const annotation = $(e.currentTarget);
            annotation.removeClass('draggable');
            annotation.find('.annotation-content').html(textarea);
            textarea.val(annotation.data('content'));
            howspace.components.autosize.init(textarea);
            textarea.trigger('focus');
        };

        viewer.on('click', '.annotation-label.editable:not(:has(.text-editor))', handleClick);
    };

    const initTextEditors = (widget, viewer) => {
        const handleKeydown = (e) => {
            if (e.key === 'Escape') {
                const annotation = $(e.currentTarget).closest('.editable');
                const content = annotation.data('content');
                howspace.components.autosize.destroy(annotation);
                annotation.find('.annotation-content').html(content.replace(/\n/g, '<br>'));
                if (widget.data('widget-type') === 'canvas') {
                    annotation.addClass('draggable');
                }
            }
        }

        const handleBlur = (e) => {
            setTimeout(() => {
                const annotation = $(e.currentTarget).closest('.editable');
                const textEditor = annotation.find('.text-editor');

                if (textEditor.length === 0) {
                    return;
                }

                const content = textEditor.val().trim();
                const oldContent = annotation.data('content');

                annotation.find('.annotation-content').html(content.replace(/\n/g, '<br>')).scrollTop(0);
                annotation.data('content', content);
                if (widget.data('widget-type') === 'canvas') {
                    annotation.addClass('draggable');
                }

                if (content === '') {
                    if (annotation.data('type') === 'label') {
                        removeMyPin(annotation);
                    }
                } else if (content !== oldContent) {
                    updateAnnotationMetadata(viewer, annotation, {content: content});
                }

                annotation.removeClass('translated');
                howspace.components.translator.init(annotation);
            });
        };

        viewer.on('keydown', '.text-editor', handleKeydown);
        viewer.on('blur', '.text-editor', handleBlur);
    };

    const initAnnotationFileUploaderModal = (modal, modalOpener) => {
        const widget = $(modalOpener).closest('.widget');
        const viewer = widget.find('.annotation-viewer');
        const toolbar = widget.find('.annotation-toolbar');
        const imageBtn = toolbar.find('.image-btn');

        if (isAnnotating(widget)) {
            stopAnnotating(widget);
        }

        stopPinning(widget);

        imageBtn.addClass('selected');

        modal.addEventListener(howspace.components.modal.MODAL_CLOSED, () => {
            requestAnimationFrame(() => {
                imageBtn.removeClass('selected');
                imageBtn.trigger('blur');
            });
        });

        modal.addEventListener(howspace.components.fileUploader.UPLOAD_COMPLETED, e => {
            howspace.components.modal.close(modal);

            const imageWidthPercentage = 10;
            const left = 50;
            const top = 50;
            const payload = {
                uploadedfile: e.detail.uploadedFiles[0].id,
                metadata: {
                    width: imageWidthPercentage
                }
            };

            postPinAnnotation(viewer, 'image', left, top, payload);

            imageBtn.removeClass('selected');
        });
    };

    const initImageTool = (widget, viewer) => {
        let isResizing = false;
        let aspectRatio, startWidth, startX;
        let resizable;

        viewer.on('pointerdown', '.editable .resize-handle', e => {
            if (e?.originalEvent?.pointerType === 'mouse' && e?.originalEvent?.button !== 0) {
                // Do not start resizing if the pointer is mouse and user didn't click with left button.
                return;
            }

            resizable = $(e.currentTarget).closest('.editable');
            resizable.addClass('resizing');
            widget.addClass('is-resizing');
            checkNoTouch();
            howspace.components.picture.pauseResize(resizable.find('.howspace-picture'));
            resizable.removeClass('draggable');

            isResizing = true;
            aspectRatio = resizable.width() / resizable.height();
            startWidth = resizable.width();
            startX = e.clientX;

            e.stopPropagation();
        });

        viewer.on('pointermove', e => {
            if (isResizing) {
                const dx = e.clientX - startX;
                const newWidth = Math.max(64, startWidth + dx);
                const newHeight = newWidth / aspectRatio;

                resizable.css({
                    width: newWidth + 'px',
                    height: newHeight + 'px'
                });
            }
        });

        viewer.on('pointerup', () => {
            if (isResizing) {
                isResizing = false;

                real.dom.$body.removeClass('no-touch');
                resizable.removeClass('resizing');
                howspace.components.picture.continueResize(resizable.find('.howspace-picture'));
                if (widget.data('widget-type') === 'canvas') {
                    resizable.addClass('draggable');
                }

                const width = resizable.width() / viewer.width() * 100;
                updateAnnotationMetadata(viewer, resizable, {width: width});

                resizable = null;
            }
        });
    };

    const initLineTool = (widget, viewer, toolbar) => {
        const lineBtn = toolbar.find('.line-btn');

        lineBtn.on('click', () => {
            if (isAnnotating(widget)) {
                stopAnnotating(widget);
            }

            if (getSelectedTool(widget) === 'line') {
                stopPinning(widget);
            } else {
                stopPinning(widget);
                lineBtn.addClass('selected');
                startPinning(widget);
            }
        });

        let isDrawing = false;
        let isResizing = false;
        let startX, startY;
        let annotation = null;
        let line = null;

        const drawLine = (x1, y1, x2, y2) => {
            line.attr({x1: x1, y1: y1, x2: x2, y2: y2});
        };

        viewer.on('pointerdown', e => {
            if (e?.originalEvent?.pointerType === 'mouse' && e?.originalEvent?.button !== 0) {
                // Do not draw line if the pointer is mouse and user didn't click with left button.
                return;
            }
            if (getSelectedTool(widget) !== 'line') {
                return;
            }
            if (isDrawing || isResizing) {
                return;
            }
            startX = e.originalEvent.offsetX;
            startY = e.originalEvent.offsetY;
            annotation = $(`<svg class="annotation-pin my-pin new-pin editable" data-type="line">
                <g>
                    <line class="line" x1="${startX}" y1="${startY}" x2="${startX}" y2="${startY}" />
                </g>
            </svg>`);
            viewer.append(annotation);
            line = annotation.find('.line');
            isDrawing = true;
        });

        viewer.on('pointerdown', '.editable .handle', e => {
            if (e?.originalEvent?.pointerType === 'mouse' && e?.originalEvent?.button !== 0) {
                // Do not move line if the pointer is mouse and user didn't click with left button.
                return;
            }
            if (isDrawing || isResizing) {
                return;
            }
            const currentHandle = $(e.currentTarget);
            annotation = currentHandle.closest('.editable');
            const otherHandle = annotation.find('.handle').not(currentHandle);
            line = annotation.find('.line');
            startX = viewer.width() * (parseFloat(otherHandle.attr('cx').replace('%', '')) / 100);
            startY = viewer.height() * (parseFloat(otherHandle.attr('cy').replace('%', '')) / 100);
            annotation.find('.handle').remove();
            annotation.removeClass('draggable');
            widget.addClass('is-resizing');
            checkNoTouch();
            annotation.addClass('resizable');
            isResizing = true;
        });

        viewer.on('pointermove', e => {
            if (isDrawing || isResizing) {
                const target = $(e.target);
                if (target.hasClass('annotation-viewer')) {
                    drawLine(startX, startY, e.originalEvent.offsetX, e.originalEvent.offsetY);
                }
            }
        });

        viewer.on('pointerup', () => {
            widget.removeClass('is-resizing');
            checkNoTouch();

            if (!annotation || !line) {
                return;
            }

            if (isDrawing) {
                isDrawing = false;

                const left = 0;
                const top = 0;
                const metadata = {
                    x1: line.attr('x1') / viewer.width() * 100,
                    y1: line.attr('y1') / viewer.height() * 100,
                    x2: line.attr('x2') / viewer.width() * 100,
                    y2: line.attr('y2') / viewer.height() * 100,
                }

                postPinAnnotation(viewer, 'line', left, top, {metadata: metadata});

                real.dom.$body.removeClass('no-touch');
                annotation.remove();
                annotation = null;
                line = null;
            }

            if (isResizing) {
                isResizing = false;

                const metadata = {
                    x1: line.attr('x1') / viewer.width() * 100,
                    y1: line.attr('y1') / viewer.height() * 100,
                    x2: line.attr('x2') / viewer.width() * 100,
                    y2: line.attr('y2') / viewer.height() * 100,
                }

                updateAnnotationMetadata(viewer, annotation, metadata);

                real.dom.$body.removeClass('no-touch');
                annotation.removeClass('resizable');
                annotation = null;
                line = null;
            }
        });
    };

    const initNoteTool = (widget, viewer, toolbar) => {
        const noteBtn = toolbar.find('.note-btn');

        noteBtn.on('click', () => {
            if (isAnnotating(widget)) {
                stopAnnotating(widget);
            }

            if (getSelectedTool(widget) === 'note') {
                stopPinning(widget);
            } else {
                stopPinning(widget);
                noteBtn.addClass('selected');
                startPinning(widget);
            }
        });

        const handleClick = (e) => {
            if (e.target.dataset.toggle === 'dropdown') {
                return;
            }
            if (widget.hasClass('is-deleting')) {
                return;
            }
            const textArea = $('<textarea class="text-editor"></textarea>');
            const annotation = $(e.currentTarget);
            if (widget.data('widget-type') === 'canvas') {
                annotation.removeClass('draggable');
            }
            annotation.find('.annotation-content').html(textArea);
            textArea.val(annotation.data('content'));
            textArea.trigger('focus');
        };

        const handlePointerLeave = (e) => {
            $(e.currentTarget).find('.annotation-content').scrollTop(0);
        };

        const saveColor = (e) => {
            const btn = $(e.currentTarget);
            const annotation = btn.closest('.annotation-note');

            howspace.components.dropdown.close(btn.closest('.dropdown'));
            e.stopPropagation();

            if (annotation.data('category') === btn.data('category')) {
                // Category didn't change, no need to save.
                return;
            }

            // Update the UI immediately.
            annotation.dataAndAttr('category', btn.data('category'));
            annotation.css({
                '--background-color': getComputedStyle(btn[0]).getPropertyValue('--background-color'),
                '--is-dark': btn.hasClass('dark-bg'),
            });

            // Save the new note category.
            updateAnnotationMetadata(viewer, annotation, {category: btn.data('category')});

            // Remember the latest note category.
            real.localStorage.set('latest-note-category', btn.data('category'));
        };

        viewer.on('click', '.annotation-note.editable:not(:has(.text-editor))', handleClick);
        viewer.on('pointerleave', '.annotation-note:not(:has(.text-editor))', handlePointerLeave);
        viewer.on('click', '.annotation-note .note-colors-menu .btn', saveColor);
    };

    const initTrashcan = (widget, viewer) => {
        const trashcan = widget.find('.trash-btn');

        trashcan.on('click', () => {
            if (isAnnotating(widget)) {
                stopAnnotating(widget);
            }
            if (isPinning(widget)) {
                stopPinning(widget);
            }
            widget.toggleClass('is-deleting');
            trashcan.toggleClass('selected');
        });

        viewer.on('click', '.editable', (e) => {
            if (widget.hasClass('is-deleting')) {
                const annotation = $(e.currentTarget);
                removeMyPin(annotation);
                widget.removeClass('is-deleting');
                trashcan.removeClass('selected');
                return false;
            }
        });
    };

    const initDragDrop = (widget, viewer) => {
        if (viewer.length === 0) {
            return;
        }

        let pointerDownElem = null;
        let draggingElem = null;
        let longPressTimeoutId = null;
        let scrollSpeed = 0;
        let scrollIntervalId = null;
        let latestX = null;
        let goingLeft = false;
        let goingRight = false;

        let widgetScrollStartX = null;
        let widgetScrollDeltaX = null;
        let dragStartX = null;
        let dragStartY = null;
        let dragDeltaX = null;
        let dragDeltaY = null;
        let dragStartLeft = null;
        let dragStartTop = null;
        let dragStartX1 = null;
        let dragStartY1 = null;
        let dragStartX2 = null;
        let dragStartY2 = null;

        const autoScroll = () => {
            if (goingLeft && widget[0].scrollLeft <= 0) {
                return;
            }

            if (goingRight && widget[0].scrollLeft >= widget[0].scrollWidth - widget[0].clientWidth) {
                return;
            }

            widget[0].scrollBy({left: scrollSpeed, behavior: 'instant'});
            widgetScrollDeltaX += scrollSpeed;
            dragDeltaX += scrollSpeed;
            updatePosition(dragDeltaX, dragDeltaY);
        };

        const checkAutoScroll = (x, deltaX) => {
            const maxWidth = window.innerWidth;
            const maxSpeed = 15;

            if (!goingLeft && deltaX < 0) {
                goingLeft = true;
                goingRight = false;
                scrollSpeed = 0;
            }
            if (!goingRight && deltaX > 0) {
                goingRight = true;
                goingLeft = false;
                scrollSpeed = 0;
            }

            if (goingLeft) {
                const percentageFromLeft = x / maxWidth * 100;
                if (percentageFromLeft <= 30) {
                    scrollSpeed = Math.ceil(Math.min(maxSpeed, (30 - percentageFromLeft) / 3) * -1);
                }
            } else if (goingRight) {
                const percentageFromRight = 100 - (x / maxWidth * 100);
                if (percentageFromRight <= 30) {
                    scrollSpeed = Math.ceil(Math.min(maxSpeed, (30 - percentageFromRight) / 3));
                }
            }

            if (scrollSpeed === 0 && scrollIntervalId !== null) {
                clearInterval(scrollIntervalId);
                scrollIntervalId = null;
            } else if (scrollIntervalId === null && scrollSpeed !== 0) {
                scrollIntervalId = setInterval(autoScroll, 10);
            }
        };

        const startDrag = () => {
            if (pointerDownElem === null) {
                return;
            }
            if (pointerDownElem.hasClass('handle') || pointerDownElem.hasClass('resize-handle')) {
                return;
            }
            draggingElem = pointerDownElem;
            if (!draggingElem.hasClass('annotation-pin')) {
                draggingElem = draggingElem.closest('.annotation-pin');
            }
            if (draggingElem.length === 0) {
                draggingElem = null;
                return;
            }

            widget.addClass('is-dragging');
            draggingElem.addClass('dragging');
            draggingElem.removeClass('editable');

            if (draggingElem.data('type') === 'line') {
                dragStartX1 = parseFloat(draggingElem.find('.line').attr('x1').replace('%', ''));
                dragStartY1 = parseFloat(draggingElem.find('.line').attr('y1').replace('%', ''));
                dragStartX2 = parseFloat(draggingElem.find('.line').attr('x2').replace('%', ''));
                dragStartY2 = parseFloat(draggingElem.find('.line').attr('y2').replace('%', ''));
            } else {
                dragStartLeft = parseInt(draggingElem.css('left').replace('px', '')) / viewer.width() * 100;
                dragStartTop = parseInt(draggingElem.css('top').replace('px', '')) / viewer.height() * 100;
            }

            if (typeof navigator.vibrate === 'function') {
                navigator.vibrate(100);
            }
        };

        const updatePosition = (deltaX, deltaY) => {
            if (draggingElem === null) {
                return;
            }

            const leftDelta = deltaX / viewer.width() * 100;
            const topDelta = deltaY / viewer.height() * 100;

            if (draggingElem.data('type') === 'line') {
                const line = draggingElem.find('.line');
                const x1 = dragStartX1 + leftDelta;
                const y1 = dragStartY1 + topDelta;
                const x2 = dragStartX2 + leftDelta;
                const y2 = dragStartY2 + topDelta;
                line.attr({x1: x1 + '%', y1: y1 + '%', x2: x2 + '%', y2: y2 + '%'});
                draggingElem.find('line.padding').attr({x1: x1 + '%', y1: y1 + '%', x2: x2 + '%', y2: y2 + '%'});
                draggingElem.find('.handle-start').attr({cx: x1 + '%', cy: y1 + '%'});
                draggingElem.find('.handle-end').attr({cx: x2 + '%', cy: y2 + '%'});
            } else {
                // Limit left and top between 0-100.
                const left = Math.min(100, Math.max(0, dragStartLeft + leftDelta));
                const top = Math.min(100, Math.max(0, dragStartTop + topDelta));
                draggingElem.css({
                    top: top + '%',
                    left: left + '%',
                });
            }
        };

        viewer.on('touchstart', () => {
            if (viewer.find('.annotation-line.selected, .annotation-image.selected').length === 0) {
                real.dom.$body.removeClass('no-touch');
            }
        });

        viewer.on('click', e => {
            if (e?.originalEvent?.button !== 0) {
                return;
            }

            const annotation = $(e.target).closest('.annotation-image.editable, .annotation-line.editable');
            const select = !annotation.hasClass('selected');
            viewer.find('.editable.selected').removeClass('selected');
            if (select) {
                annotation.addClass('selected');
                if (annotation.hasClass('annotation-line') || annotation.hasClass('annotation-image')) {
                    real.dom.$body.addClass('no-touch');
                }
            }
        });

        viewer.on('contextmenu', '.draggable', e => {
            if (pointerDownElem !== null && e.originalEvent.button <= 0) {
                // Do not open context menu when long pressing a draggable annotation in mobile.
                e.preventDefault();
            }
        });

        viewer.on('pointerdown', '.draggable', e => {
            if (widget.hasClass('is-deleting')) {
                return;
            }

            e = e.originalEvent;
            if (e.button === 0 && e.buttons > 0) {
                // Pointer down happened with the left mouse button.
                try {
                    e.target.setPointerCapture(e.pointerId);
                } catch (e) {
                    // Ignore the error if the target doesn't support pointer capture.
                }

            }
        });

        viewer.on('mousedown', '.draggable', e => {
            if (widget.hasClass('is-deleting')) {
                return;
            }

            e = e.originalEvent;
            if (e.button !== 0 || e.buttons === 0) {
                // User clicked with something other than left mouse button.
                return;
            }

            pointerDownElem = $(e.target);
            dragStartX = e.pageX;
            dragStartY = e.pageY;
        });

        const highlightLongPress = () => {
            const longPressIndicator = $('<div class="long-press-drag-start-indicator"></div>');
            longPressIndicator.css({
                left: dragStartX + 'px',
                top: dragStartY + 'px',
            });
            viewer.append(longPressIndicator);

            setTimeout(() => {
                longPressIndicator.css({
                    width: '8rem',
                    height: '8rem',
                    opacity: 0,
                });
            }, 10);

            setTimeout(() => {
                longPressIndicator.remove();
            }, 500);
        };

        viewer.on('touchstart', '.draggable', e => {
            if (widget.hasClass('is-deleting')) {
                return;
            }

            e = e.originalEvent;
            let target = $(e.target);
            if (!target.hasClass('annotation-pin')) {
                target = target.closest('.annotation-pin');
            }
            if (target.find('.text-editor').length > 0) {
                return;
            }

            pointerDownElem = target;
            widgetScrollStartX = widget[0].scrollLeft;
            dragStartX = e.touches[0].pageX;
            dragStartY = e.touches[0].pageY;
            longPressTimeoutId = setTimeout(() => {
                longPressTimeoutId = null;
                startDrag();
                highlightLongPress();
            }, 700);
        });

        viewer.on('mousemove', e => {
            if (pointerDownElem === null) {
                return;
            }

            e = e.originalEvent;
            dragDeltaX = e.pageX - dragStartX;
            dragDeltaY = e.pageY - dragStartY;

            if (draggingElem === null && (Math.abs(dragDeltaX) > 10 || Math.abs(dragDeltaY) > 10)) {
                // Pointer moved over 10px, start the drag.
                startDrag();
                return;
            }

            if (draggingElem !== null) {
                // Update the drag element position.
                updatePosition(dragDeltaX, dragDeltaY);
            }
        });

        // Note that we are using a native event listener here because preventing default scroll behavior
        // needs to be done with {passive: false} and jQuery doesn't support that.
        viewer[0].addEventListener('touchmove', e => {
            if (pointerDownElem === null) {
                return;
            }

            widgetScrollDeltaX = widget[0].scrollLeft - widgetScrollStartX;
            dragDeltaX = e.touches[0].pageX - dragStartX + widgetScrollDeltaX;
            dragDeltaY = e.touches[0].pageY - dragStartY;

            if (longPressTimeoutId !== null && (Math.abs(dragDeltaX) > 10 || Math.abs(dragDeltaY) > 10)) {
                // We were waiting for long press to complete, but pointer moved over 10px. Cancel the long press.
                clearTimeout(longPressTimeoutId);
                longPressTimeoutId = null;
                return;
            }

            if (draggingElem !== null) {
                // Prevent default scroll behavior.
                e.preventDefault();

                // Update the drag element position.
                updatePosition(dragDeltaX, dragDeltaY);

                // Check if we need to scroll the widget.
                const latestDeltaX = e.touches[0].pageX - (latestX || 0);
                checkAutoScroll(e.touches[0].pageX, latestDeltaX);
                latestX = e.touches[0].pageX;
            }
        }, {passive: false});

        viewer.on('mouseup touchend', () => {
            widget.removeClass('is-dragging');

            if (pointerDownElem === null) {
                return;
            }

            pointerDownElem = null;

            if (longPressTimeoutId !== null) {
                clearTimeout(longPressTimeoutId);
                longPressTimeoutId = null;
                return;
            }

            scrollSpeed = 0;
            if (scrollIntervalId !== null) {
                clearInterval(scrollIntervalId);
                scrollIntervalId = null;
            }

            if (draggingElem === null) {
                return;
            }

            if (draggingElem.data('type') === 'line') {
                const metadata = {
                    x1: parseFloat(draggingElem.find('.line').attr('x1').replace('%', '')),
                    y1: parseFloat(draggingElem.find('.line').attr('y1').replace('%', '')),
                    x2: parseFloat(draggingElem.find('.line').attr('x2').replace('%', '')),
                    y2: parseFloat(draggingElem.find('.line').attr('y2').replace('%', '')),
                }
                updateAnnotationMetadata(viewer, draggingElem, metadata);
            } else {
                const metadata = {
                    left: parseInt(draggingElem.css('left').replace('px', '')) / viewer.width() * 100,
                    top: parseInt(draggingElem.css('top').replace('px', '')) / viewer.height() * 100,
                }
                updateAnnotationMetadata(viewer, draggingElem, metadata);
            }

            draggingElem.removeClass('dragging').addClass('dropped');
            draggingElem = null;
        });
    };

    const initVisibility = (widget, viewer, toolbar) => {
        const toggleBtn = toolbar.find('.annotation-visibility-dropdown-toggle-btn');
        toolbar.on('click', '.annotation-visibility-btn', (e) => {
            const btn = $(e.target);
            viewer.dataAndAttr('visibility', btn.data('visibility'));
            toggleBtn.find('.btn-text').text(btn.find('.btn-text').text());
            viewer.find('.new-pin').removeClass('new-pin');
        });
    };

    return {
        initView: (widget) => {
            const legend = widget.find('.annotation-legend');
            const viewer = widget.find('.annotation-viewer');
            const toolbar = widget.find('.annotation-toolbar');

            // Tools.
            initAnnotationTool(widget, toolbar);
            initPinTool(widget, legend, viewer, toolbar);
            initEmojiTool(widget, viewer, toolbar);
            initLabelTool(widget, viewer, toolbar);
            initImageTool(widget, viewer);
            initLineTool(widget, viewer, toolbar);
            initNoteTool(widget, viewer, toolbar);
            initTrashcan(widget, viewer);
            initTextEditors(widget, viewer);
            initDragDrop(widget, viewer);
            initVisibility(widget, viewer, toolbar);

            // Get pins.
            if (widget.data('pinning-mode') !== 'none') {
                getPins(widget);
            }
        },
        initEdit: (widget) => {
            // Add pinning option button.
            widget.find('.add-pinning-option-btn').on('click', () => {
                const sortableList = widget.find('.pinning-options-sortable-list');
                const option = howspace.components.sortableList.addItem(sortableList);
                const index = (sortableList.find('.option').length - 1) % howspace.components.colorPicker.getPalette().length;
                const color = howspace.components.colorPicker.getPalette()[index];
                howspace.components.colorPicker.setColor(option.find('.howspace-color-picker'), color);
            });
        },
        destroyView: (widget) => {
            widget.removeClass('is-pinning is-resizing');
            checkNoTouch();
        },
        getPins: getPins,
        postAnnotation: postAnnotation,
        showAnnotation: showAnnotation,
        handlePageLoading: handlePageLoading,
        handlePageChanged: handlePageChanged,
        initAnnotationFileUploaderModal: initAnnotationFileUploaderModal
    };
})();
